import { useLocation, useNavigate } from "react-router-dom";
export function useRouterPath() {
    const router = useLocation();
    const navigate = useNavigate();
    const doNavigation = (path) => { navigate(path); };
    return [router.pathname, doNavigation];
}
